<div class="ticket-container ">
  <div class="text-center form-group">
    <button routerLink="/seller/team/add/member" class="btn btn-primary">
      {{ 'Sellers.Products.AddTeamMember' | translate }}
    </button>
  </div>
</div>
<div>
  <app-base-report *ngIf="teamManagementReportData" [hasCheckboxes]="false" [reportName]="reportName" [defaultColumns]="displayedColumns"
                   [columnsDisplayNames]="displayTableColumns" [data]="teamManagementReportData" [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)" (paginationChange)="paginate($event)" (searchChange)="searchChange($event)"
                   [tableLoading]="loading" [hasSort]="true" (sortTrigger)="sortChange($event)" [rowActions]="rowActions"
                   (rowActionClicked)="onRowAction($event)" [rowActionKeyName]='token' [serviceInstance]="teamManagementService">
  </app-base-report>
</div>
